export default __webpack_public_path__ + "static/media/mximg8.03c0e59a.webp";